import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/join/$identifier")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/clubs/$identifier",
      params: { identifier: params.identifier },
    });
  },
});
